import { schQueryParams } from '@aloft/toolkit-shared';

import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useRecommendedCompsFilterRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  const setFiltersRoute = useCallback(
    (shouldOpen: boolean) => {
      const params = new URLSearchParams(location.search);
      const isFilterRoute = params.get(schQueryParams.enum.filters) === 'true';

      if (shouldOpen && isFilterRoute) return;
      if (!shouldOpen && !params.has(schQueryParams.enum.filters)) return;

      if (shouldOpen) {
        params.set(schQueryParams.enum.addComps, 'true');
        params.set(schQueryParams.enum.filters, 'true');
      } else {
        params.delete(schQueryParams.enum.filters);
      }

      navigate({ search: params.toString() }, { replace: true });
    },
    [location.search, navigate],
  );

  const openFilterDrawer = useCallback(() => {
    setIsFilterDrawerOpen(true);
    setFiltersRoute(true);
  }, [setFiltersRoute]);

  const closeFilterDrawer = useCallback(() => {
    setIsFilterDrawerOpen(false);
    setFiltersRoute(false);
  }, [setFiltersRoute]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const shouldOpen = params.get(schQueryParams.enum.filters) === 'true';
    setIsFilterDrawerOpen(shouldOpen);
  }, [location.search]);

  return {
    isFilterDrawerOpen,
    onFilterDrawerOpen: openFilterDrawer,
    onFilterDrawerClose: closeFilterDrawer,
  };
};
